import React from "react";
import { ChevronDown } from "lucide-react";

/** Sezione richiudibile della cartella clinica (freccetta + header sticky-friendly). */
export default function CollapsibleSection({ id, title, icon: Icon, badge, open, onToggle, children, accent = "#2C4667" }) {
  return (
    <section className="mb-4 rounded-xl border border-[#E2E8F0] bg-white overflow-hidden" data-testid={`section-${id}`}>
      <button
        type="button"
        data-testid={`section-toggle-${id}`}
        onClick={() => onToggle(id)}
        className="w-full flex items-center gap-3 px-4 py-3 bg-slate-50/80 hover:bg-slate-100 transition-colors text-left"
        style={{ borderLeft: `4px solid ${accent}` }}
      >
        {Icon && <Icon size={17} style={{ color: accent }} className="shrink-0" />}
        <span className="font-extrabold text-brand-navy text-sm uppercase tracking-wide flex-1">{title}</span>
        {badge}
        <ChevronDown
          size={18}
          className={`text-slate-500 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
        />
      </button>
      <div className={open ? "p-4" : "hidden"} data-testid={`section-body-${id}`}>
        {children}
      </div>
    </section>
  );
}
